export enum FILTER_TYPE {
  FILTERS = 'filters',
  PROVIDERS = 'providers',
  SEARCH = 'search',
}
